<template>
  <img class="title" src="./assets/banner2.png" />
  <div class="border" style="text-align: center">
    <!-- Disable this per Jerry request -->

    <div class="password" style="display: inline-block" @click="resetpassword">
      <img src="./assets/resetpassword.png" mx-auto />
      <h3>Reset Password</h3>
    </div>
    <div class="email" @click="emailQuar" style="display: inline-block">
      <img src="./assets/quarantine.png" />
      <h3>Access Email Quarantine</h3>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    resetpassword() {
      window.open("https://aka.ms/sspr");
    },
    emailQuar() {
      window.open("https://security.microsoft.com/quarantine");
    },
  },
};
</script>

<style>
.title {
  width: 100%;
}
.email {
  padding-left: 25px;
  padding-right: 25px;
}
.password {
  padding-left: 25px;
  padding-right: 25px;
}
.border {
  margin-top: -4px;
  border: 15px solid rgb(220, 219, 219);
  height: auto;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
